import React from 'react';
import PropTypes from 'prop-types';

const CheckedBullet = ({ color = '#F7F7F7', fillColor = '#14AE5C', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={21} viewBox="0 0 20 21" fill="none" {...props}>
    <path fill={fillColor} d="M10 19.567a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.334Z" />
    <path
      fill={color}
      fillRule="evenodd"
      d="m8.334 14.567-3.138-3.093a.65.65 0 0 1 0-.93.673.673 0 0 1 .942 0l2.196 2.164 5.528-5.449a.673.673 0 0 1 .943 0 .65.65 0 0 1 0 .93l-6.471 6.378Z"
      clipRule="evenodd"
    />
  </svg>
);

CheckedBullet.propTypes = {
  color: PropTypes.string,
  fillColor: PropTypes.string
};

export default CheckedBullet;
